import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { MatSnackBar } from "@angular/material";
import { environment } from '../../environments/environment';

import { PublicacionService } from '../services/publicacion.service';
import { Publicacion } from '../models/publicacion';
import { PublicacionEditorComponent } from '../publicacion-editor/publicacion-editor.component';
import { PublicacionImgExtraEditorComponent } from '../publicacion-img-extra-editor/publicacion-img-extra-editor.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-publicacion-list',
  templateUrl: './publicacion-list.component.html',
  styleUrls: ['./publicacion-list.component.css']
})
export class PublicacionListComponent implements OnInit {


  models: Publicacion[];
  Url = environment.imgUrl;

  constructor(private modelService: PublicacionService, public dialog: MatDialog, private snackBar: MatSnackBar) {
    this.models = [];
  }

  ngOnInit() {
    this.getAll();
  }

  openEditor(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: id
    };

    const dialogRef = this.dialog.open(PublicacionEditorComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        this.getAll();
        if (data != undefined && data != 0) this.openPublicacionImgExtraEditor(data);
      }
    );
  }
  openPublicacionImgExtraEditor(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: id
    };

    const dialogRef = this.dialog.open(PublicacionImgExtraEditorComponent, dialogConfig);
  }

  delete(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '300px';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data == true) {
          this.modelService.delete(id).subscribe(
            val => {
              this.getAll();
              this.snackBar.open('Registro Eliminado', '', {
                duration: 2000,
              });
            });
        }
      }
    );

  }

  getAll() {

    let filter = {
    }

    this.modelService.getFilter(filter).subscribe(val => {
      this.models = val;

    },
      error => {
        console.log(error);
        console.log(<any>error);
      });

  }

  destacado(id, destacado) {

    let change = {
      id: id,
      destacado: destacado
    }
    this.modelService.destacado(change, id).subscribe(
      val => {
        if (val.status == true) {
          this.getAll();
          this.snackBar.open(val.message, '', {
            duration: 2000,
          });
        }
        else {
          this.snackBar.open(val.message, '', {
            duration: 2000,
            panelClass: ['red-snackbar']
          });
        }

      },
      error => {
        console.log(<any>error);
        this.snackBar.open('Intente de nuevo, ocurrio un error', '', {
          duration: 3000,
          panelClass: ['red-snackbar']
        });
      });
  }
}
